"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { cva as B } from "class-variance-authority";
import { forwardRef as T, useState as V } from "react";
import { twMerge as j } from "tailwind-merge";
import { cn as r } from "../../../utils/utils.mjs";
import { Text as _ } from "../Text/Text.mjs";
import { getAccessibleFocusStyles as A } from "../../../utils/styles.mjs";
const N = B(
  `
    px-6
    rounded-sm
    ${A()}
    cursor-pointer
    text-center
    border-transparent
    border-2
    flex
    items-center
    justify-center
    gap-x-2
    w-full
`,
  {
    variants: {
      variant: {
        primary: "bg-yellow-400 hover:bg-yellow-600 text-gray-900",
        secondary: "bg-gray-800 hover:bg-gray-900 text-white",
        "outlined-dark": "border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white",
        "outlined-light": "border-white text-white hover:text-gray-800 hover:bg-white hover:border-gray-800",
        "outlined-gradient": "border-transparent text-white",
        text: "bg-transparent text-blue-700 hover:bg-gray-100 hover:text-blue-800",
        alternate: "bg-blue-700 hover:bg-blue-800 text-white"
      },
      size: {
        default: "py-1-5 min-h-[40px]",
        large: "py-3 min-h-[56px]"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 border-gray-200 hover:border-gray-200 focus:outline-none hover:bg-gray-200 hover:text-gray-500 cursor-not-allowed"
      },
      isLink: {
        true: "inline-flex items-center"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), h = B("w-4 h-4 fill-current hover:fill-current", {
  variants: {
    variant: {
      primary: "fill-current hover:fill-current",
      secondary: "fill-white hover:fill-gray-900",
      "outlined-dark": "fill-gray-800 hover:fill-white",
      "outlined-light": "fill-current hover:fill-current",
      "outlined-gradient": "fill-current hover:fill-current",
      text: "fill-current hover:fill-current",
      alternate: "fill-white hover:fill-gray-200"
    },
    disabled: {
      true: "fill-gray-500 hover:fill-gray-500"
    }
  }
}), R = "bg-conic-225 from-amethyst-500 from-0% via-bubblegum-500 to-amethyst-500", C = "bg-[conic-gradient(transparent_0deg,transparent_270deg,var(--color-amethyst-500)_300deg,var(--color-orange-100)_330deg,var(--color-bubblegum-500)_345deg,transparent_360deg)]", F = "transition-opacity duration-300", G = ({ animated: i }) => /* @__PURE__ */ e(
  "span",
  {
    "aria-hidden": "true",
    className: r(
      "pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden rounded-sm p-0-5",
      "mask-[linear-gradient(black,black),linear-gradient(black,black)] [mask-clip:content-box,border-box] mask-exclude"
    ),
    children: /* @__PURE__ */ l("span", { className: "relative aspect-square w-[200%] shrink-0", children: [
      i && /* @__PURE__ */ e(
        "span",
        {
          className: r(
            "absolute inset-0",
            C,
            F,
            "animate-[spin_3s_linear_infinite] group-hover/gradient-border:opacity-0",
            /* A frozen arc reads as a rendering fault, so reduced motion drops to the full sweep below. */
            "motion-reduce:hidden"
          )
        }
      ),
      /* @__PURE__ */ e(
        "span",
        {
          className: r(
            "absolute inset-0",
            R,
            i && r(F, "opacity-0 group-hover/gradient-border:opacity-100 motion-reduce:opacity-100")
          )
        }
      )
    ] })
  }
), O = T(
  ({
    children: i,
    variant: a,
    className: E = "",
    buttonClassName: g = "",
    size: s = "default",
    disabled: t = !1,
    animatedBorder: L = !1,
    href: m,
    iconPrefix: n,
    iconSuffix: b,
    onFocus: c,
    onBlur: u,
    ...f
  }, p) => {
    const y = s === "large" ? "base" : "sm", [S, v] = V(!1), x = (o) => {
      o.currentTarget.matches(":focus-visible") && v(!0), c == null || c(o);
    }, w = (o) => {
      v(!1), u == null || u(o);
    }, k = a === "outlined-gradient" && !t;
    let d;
    return m && !t ? d = /* @__PURE__ */ l(
      "a",
      {
        ...f,
        ref: p,
        className: r(N({ variant: a, size: s, disabled: t, isLink: !0 }), g),
        href: m,
        onFocus: x,
        onBlur: w,
        children: [
          n && /* @__PURE__ */ e("div", { className: r(h({ variant: a, disabled: t })), children: n }),
          /* @__PURE__ */ e(_, { asChild: !0, fontSize: y, children: /* @__PURE__ */ e("span", { children: i }) })
        ]
      }
    ) : d = /* @__PURE__ */ l(
      "button",
      {
        ...f,
        ref: p,
        className: r(N({ variant: a, size: s, disabled: t }), g),
        disabled: t,
        onFocus: x,
        onBlur: w,
        children: [
          n && /* @__PURE__ */ e("div", { className: r(h({ variant: a, disabled: t })), children: n }),
          /* @__PURE__ */ e(_, { asChild: !0, fontSize: y, children: /* @__PURE__ */ e("span", { children: i }) }),
          b && /* @__PURE__ */ e("div", { className: r(h({ variant: a, disabled: t })), children: b })
        ]
      }
    ), /* @__PURE__ */ l(
      "div",
      {
        className: j(
          "inline-block rounded-sm w-auto",
          k && "relative group/gradient-border",
          S && "focus-within:outline-2 focus-within:outline-white focus-within:outline-offset-2",
          E
        ),
        children: [
          k && /* @__PURE__ */ e(G, { animated: L }),
          d
        ]
      }
    );
  }
);
O.displayName = "Button";
export {
  O as Button
};
